import { useState } from "react";
import { AppBar, Toolbar, Box, Typography, IconButton } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import { Link } from "react-router-dom";
import { SearchBar } from "@/components/search";
import { UserProfileMenu } from "./UserProfileMenu";
import { MobileDrawer } from "./MobileDrawer";
import aosLogo from "@/assets/images/aos-logo.png";

export function AppHeader() {
  const [mobileOpen, setMobileOpen] = useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  return (
    <>
      <MobileDrawer open={mobileOpen} onClose={() => setMobileOpen(false)} />
      <AppBar
        position="sticky"
        elevation={0}
        sx={{
          bgcolor: "background.paper",
          borderBottom: "1px solid",
          borderColor: "divider",
        }}
      >
        <Toolbar
          sx={{
            gap: 2,
            minHeight: 56,
          }}
        >
          {/* Mobile Menu Button */}
          <IconButton
            color="inherit"
            aria-label="Open navigation menu"
            edge="start"
            onClick={handleDrawerToggle}
            sx={{ display: { md: "none" }, color: "text.primary" }}
          >
            <MenuIcon />
          </IconButton>

          {/* Logo and Brand */}
          <Box
            component={Link}
            to="/dashboard"
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1.5,
              textDecoration: "none",
              color: "inherit",
              flexShrink: 0,
            }}
          >
            <Box
              component="img"
              src={aosLogo}
              alt="AOS Logo"
              sx={{
                height: 36,
                width: "auto",
              }}
            />
            <Typography
              variant="h6"
              sx={{
                fontWeight: 700,
                color: "text.primary",
                display: { xs: "none", sm: "block" },
                letterSpacing: "0.02em",
              }}
            >
              <Box component="span" sx={{ color: "primary.main" }}>
                AOS
              </Box>{" "}
              PATHWAYS
            </Typography>
          </Box>

          {/* Search - centered, takes available space */}
          <Box
            sx={{
              flexGrow: 1,
              display: "flex",
              justifyContent: "center",
              maxWidth: 600,
              mx: "auto",
            }}
          >
            <SearchBar />
          </Box>

          {/* User menu */}
          <Box sx={{ flexShrink: 0 }}>
            <UserProfileMenu />
          </Box>
        </Toolbar>
      </AppBar>
    </>
  );
}
